var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 94.969,
    viewBox: "0 0 88 94.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-create-doc",
    transform: "translate(-8 -2.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M16,81.44H49v8H15a7.016,7.016,0,0,1-7-7.016V9.046a7.015,7.015,0,0,1,7-7.015H62.792a7.939,7.939,0,0,1,5.665,2.356L85.478,21.5a7.979,7.979,0,0,1,2.335,5.67V50.259h-8v-23.1L62.785,10.03H16Zm33,7.993,4.614.012L49,81.436ZM79.809,50.259l8.008,4.616-.012-4.614ZM96,76.9a20,20,0,1,1-20-20.1A20.052,20.052,0,0,1,96,76.9Zm-6-4.02H80V62.824H72V72.876H62v8.041H72V90.969h8V80.917H90Z",
    fill: "#0071b9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateDoc);
export default __webpack_public_path__ + "static/media/create-doc.a6451632122edc4529371aa39ed2f666.svg";
export { ForwardRef as ReactComponent };